import React from "react";
import { Link } from "react-router-dom";
export default function Navbar() {
  return (
    <div className="container-lg" style={{ "backgroundColor":"#563d7c"}}>
      <nav className="navbar navbar-light ps-3">
        <Link to="/" className="navbar-brand text-white">
          Tasks
        </Link>
      </nav>
    </div>
  );
}
